var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
var numberColsFixed = 3;
var keywords = [
    'INFLOW',
    'OUTFLOW',
    'NETFLOW',
    'I. Cash flow from business activities',
    'II. Cash flow from investment activities',
    'III. Cash flow from financial activities'
];
/**
 *
 * @description Custom config in HandsonTable
 *
 * @author phamlam2k
 *
 * @returns
 */
var useCashFlowHandsonTableConfig = function (props) {
    var handleCheckRequiredColumnsAfterDrop = props === null || props === void 0 ? void 0 : props.handleCheckRequiredColumnsAfterDrop;
    // ---------------------------------
    // State and Form Initialization
    // ---------------------------------
    var _a = useState([100, 300, 180, 120, 120, 120, 120, 120, 120, 120, 120, 120, 120, 120]), colWidths = _a[0], setColWidths = _a[1];
    // ---------------------------------
    // Functions
    // ---------------------------------
    /**
     *
     * @description Get merge cells and hightlight it by conditional "keywords"
     *
     * @param data
     *
     * @returns
     */
    var generateMergeCells = function (data) {
        var mergeCells = [];
        var highlightedRows = new Set();
        data.forEach(function (row, rowIndex) {
            row.forEach(function (cell, colIndex) {
                if (typeof cell === 'string' && keywords.includes(cell.trim())) {
                    mergeCells.push({
                        row: rowIndex,
                        col: colIndex,
                        rowspan: 1,
                        colspan: data[0].length - colIndex
                    });
                    highlightedRows.add(rowIndex);
                }
            });
        });
        return { mergeCells: mergeCells, highlightedRows: highlightedRows };
    };
    /**
     *
     * @description Custom Popup menu when right click the column
     *
     * @param type - 'create' | 'edit' | 'detail'
     *
     * @returns
     */
    var contextMenu = function (type) {
        var context = {
            items: {
                col_left: {
                    hidden: function () {
                        var _a;
                        if (type === 'create') {
                            return ((_a = this.getSelectedLast()) === null || _a === void 0 ? void 0 : _a[1]) < numberColsFixed - 1;
                        }
                        return true;
                    },
                    callback: function (_, selection) {
                        var _this = this;
                        var colIndex = selection[selection.length - 1].start.col;
                        setColWidths(function (prev) { return __spreadArray(__spreadArray([], prev, true), [120], false); });
                        setTimeout(function () {
                            _this.alter('insert_col_start', selection[0].start.col);
                        }, 0);
                        var data = this.getData().map(function (row, rowIndex) {
                            var newRow = __spreadArray([], row, true);
                            if (rowIndex === 1) {
                                newRow.splice(colIndex, 0, null);
                            }
                            else {
                                newRow.splice(colIndex, 0, null);
                            }
                            return newRow;
                        });
                        handleCheckRequiredColumnsAfterDrop && handleCheckRequiredColumnsAfterDrop(colIndex, colIndex + 1);
                        setTimeout(function () {
                            _this.loadData(data);
                        }, 10);
                    }
                },
                col_right: {
                    hidden: function () {
                        var _a;
                        if (type === 'create') {
                            return ((_a = this.getSelectedLast()) === null || _a === void 0 ? void 0 : _a[1]) < numberColsFixed - 1;
                        }
                        return true;
                    },
                    callback: function (_, selection) {
                        var _this = this;
                        var colIndex = selection[selection.length - 1].end.col + 1;
                        setTimeout(function () {
                            _this.alter('insert_col_end', selection[selection.length - 1].end.col);
                        }, 0);
                        var data = this.getData().map(function (row, rowIndex) {
                            var newRow = __spreadArray([], row, true); // Copy dữ liệu từng hàng
                            if (rowIndex === 1) {
                                newRow.splice(colIndex, 0, null); // Chỉ thêm giá trị vào hàng 1
                            }
                            else {
                                newRow.splice(colIndex, 0, ''); // Thêm cột mới nhưng để trống ở các hàng khác
                            }
                            return newRow;
                        });
                        handleCheckRequiredColumnsAfterDrop && handleCheckRequiredColumnsAfterDrop(colIndex, colIndex + 1);
                        setTimeout(function () {
                            _this.loadData(data);
                        }, 10);
                        setColWidths(function (prev) { return __spreadArray(__spreadArray([], prev, true), [120], false); });
                    }
                },
                clear_column: {
                    name: function () {
                        return 'Delete column(s)';
                    },
                    hidden: function () {
                        var _a;
                        if (type === 'create') {
                            return ((_a = this.getSelectedLast()) === null || _a === void 0 ? void 0 : _a[1]) < numberColsFixed;
                        }
                        return true;
                    },
                    callback: function (_, selection) {
                        var _this = this;
                        if (!selection || selection.length === 0)
                            return;
                        var colIndex = selection[selection.length - 1].end.col + 1;
                        var colIndexes = selection.map(function (s) { return s.start.col; });
                        var data = this.getData().map(function (row) { return __spreadArray([], row, true); });
                        var updatedData = data.map(function (row) { return row.filter(function (_, colIndex) { return !colIndexes.includes(colIndex); }); });
                        handleCheckRequiredColumnsAfterDrop && handleCheckRequiredColumnsAfterDrop(colIndex, colIndex - 1);
                        setColWidths(function (prev) { return prev.slice(0, -colIndexes.length); });
                        setTimeout(function () {
                            colIndexes.forEach(function (col) {
                                _this.alter('remove_col', col);
                            });
                        }, 0);
                        setTimeout(function () {
                            _this.loadData(updatedData);
                        }, 10);
                    }
                }
            }
        };
        return context;
    };
    /**
     *
     * @description Validate the column
     *
     * @param type - 'create' | 'edit' | 'detail'
     *
     * @returns
     */
    var cellValidator = function (value, callback) {
        if (value === null || value === '') {
            setTimeout(function () {
                callback(false);
            }, 1000);
        }
        else {
            callback(true);
        }
    };
    /**
     *
     * @description Compute the totals of the data
     *
     * @param data
     * @param amountIndex
     *
     * @returns
     */
    var computeTotals = function (data, amountIndex) {
        if (amountIndex === void 0) { amountIndex = 3; }
        var resultData = __spreadArray([], data, true); // clone để xử lý
        // Biến lưu vị trí dòng keyword và sections
        var keywordRows = {
            INFLOW: -1,
            OUTFLOW: -1,
            NETFLOW: -1
        };
        var sections = {
            inflow: {
                section1: { start: -1, end: -1, total: 0 },
                section2: { start: -1, end: -1, total: 0 },
                section3: { start: -1, end: -1, total: 0 }
            },
            outflow: {
                section1: { start: -1, end: -1, total: 0 },
                section2: { start: -1, end: -1, total: 0 },
                section3: { start: -1, end: -1, total: 0 }
            }
        };
        // Tìm vị trí các dòng INFLOW/OUTFLOW/NETFLOW trước
        data.forEach(function (row, index) {
            var text = row[1];
            if (typeof text === 'string') {
                if (text.trim() === 'INFLOW')
                    keywordRows.INFLOW = index;
                else if (text.trim() === 'OUTFLOW')
                    keywordRows.OUTFLOW = index;
                else if (text.trim() === 'NETFLOW')
                    keywordRows['NETFLOW'] = index;
            }
        });
        // Sau đó tìm các section và phân loại theo INFLOW/OUTFLOW
        data.forEach(function (row, index) {
            var text = row[1];
            if (typeof text === 'string') {
                // Xác định section thuộc INFLOW hay OUTFLOW
                var isInflow = index > keywordRows.INFLOW && index < keywordRows.OUTFLOW;
                var isOutflow = index > keywordRows.OUTFLOW && index < keywordRows['NETFLOW'];
                var targetSection = isInflow ? sections.inflow : isOutflow ? sections.outflow : null;
                if (targetSection) {
                    if (text.includes('I. Cash flow from business activities')) {
                        if (isInflow) {
                            sections.inflow.section1.start = index;
                        }
                        else {
                            sections.outflow.section1.start = index;
                        }
                    }
                    else if (text.includes('II. Cash flow from investment activities')) {
                        if (isInflow) {
                            sections.inflow.section1.end = index;
                            sections.inflow.section2.start = index;
                        }
                        else {
                            sections.outflow.section1.end = index;
                            sections.outflow.section2.start = index;
                        }
                    }
                    else if (text.includes('III. Cash flow from financial activities')) {
                        if (isInflow) {
                            sections.inflow.section2.end = index;
                            sections.inflow.section3.start = index;
                            sections.inflow.section3.end = keywordRows.OUTFLOW;
                        }
                        else {
                            sections.outflow.section2.end = index;
                            sections.outflow.section3.start = index;
                            sections.outflow.section3.end = keywordRows['NETFLOW'];
                        }
                    }
                }
            }
        });
        // Helper: kiểm tra một hàng có thuộc section không
        var isInSection = function (row, section) {
            return row > section.start && row < section.end && section.start !== -1 && section.end !== -1;
        };
        var inflowTotal = 0;
        var outflowTotal = 0;
        // Tính tổng cho từng section
        data.forEach(function (row, index) {
            var amount = parseFloat(row[amountIndex] || 0);
            if (isNaN(amount))
                return;
            // INFLOW sections
            if (index > keywordRows.INFLOW && index < keywordRows.OUTFLOW) {
                if (isInSection(index, sections.inflow.section1)) {
                    sections.inflow.section1.total += amount;
                }
                else if (isInSection(index, sections.inflow.section2)) {
                    sections.inflow.section2.total += amount;
                }
                else if (isInSection(index, sections.inflow.section3)) {
                    sections.inflow.section3.total += amount;
                }
            }
            // OUTFLOW sections
            else if (index > keywordRows.OUTFLOW && index < keywordRows['NETFLOW']) {
                if (isInSection(index, sections.outflow.section1)) {
                    sections.outflow.section1.total += amount;
                }
                else if (isInSection(index, sections.outflow.section2)) {
                    sections.outflow.section2.total += amount;
                }
                else if (isInSection(index, sections.outflow.section3)) {
                    sections.outflow.section3.total += amount;
                }
            }
        });
        // Gán tổng vào các dòng section và tính tổng INFLOW/OUTFLOW
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(sections.inflow).forEach(function (_a) {
            var _ = _a[0], section = _a[1];
            if (section.start !== -1) {
                resultData[section.start][amountIndex] = section.total;
                inflowTotal += section.total;
            }
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(sections.outflow).forEach(function (_a) {
            var _ = _a[0], section = _a[1];
            if (section.start !== -1) {
                resultData[section.start][amountIndex] = section.total;
                outflowTotal += section.total;
            }
        });
        // Gán tổng INFLOW và OUTFLOW
        if (keywordRows.INFLOW !== -1) {
            resultData[keywordRows.INFLOW][amountIndex] = inflowTotal;
        }
        if (keywordRows.OUTFLOW !== -1) {
            resultData[keywordRows.OUTFLOW][amountIndex] = outflowTotal;
        }
        if (keywordRows['NETFLOW'] !== -1) {
            resultData[keywordRows['NETFLOW']][amountIndex] = inflowTotal - outflowTotal;
        }
        return resultData;
    };
    return {
        colWidths: colWidths,
        contextMenu: contextMenu,
        cellValidator: cellValidator,
        generateMergeCells: generateMergeCells,
        computeTotals: computeTotals
    };
};
export default useCashFlowHandsonTableConfig;
